module.exports = __webpack_public_path__ + "static/scale-model-of-cincinnati-ohio-ba3f6b0b64cc530aff86d559e15d0c05.png";